import React, { useContext } from "react"
import { Link } from "react-router-dom"
import {
  OpenAssistantButton,
  OpenMessagesButton,
  OpenNotificationsButton,
  OpenMenuButton,
  StaffStats,
  StaffPipeline,
  Logo
} from "@smaller-earth/postcard-components"
import { MenuHeader, DesktopHide, Buttons, Wrapper } from "./styles"
import MenuContext from "@context/MenuContext"
import UserContext from "@context/UserContext"
import { getBrand } from "@helpers/siteHelpers"
import useFeature, { FEATURE_NEW_PLACEMENT_FLOW } from "@hooks/useFeature"

const HeaderBar = (props) => {
  const { friendlyName, colouredLogo } = getBrand()
  const { toggleMenu } = useContext(MenuContext)
  const { messagingEnabled, messageCount, notificationCount, staffCounts } = useContext(UserContext).menu
  // New placement flow shows a different "My Staff" pipeline (Applied/Invited/Scheduled/
  // Interviewed/Offered/Hired) via a dedicated component; legacy employers keep the original
  // Watchlist/On Review/… bar. Both take the same props.
  const StaffBar = useFeature(FEATURE_NEW_PLACEMENT_FLOW) ? StaffPipeline : StaffStats

  return (
    <MenuHeader inAdminView={props.inAdminView}>
      {staffCounts && <StaffBar desktopOnly={true} staffCounts={staffCounts} homePage={props.homePage} />}

      <Wrapper className="ho-header-wrapper">
        <Link to="/">
          <Logo src={colouredLogo} alt={friendlyName} tabletOnly medium />
        </Link>

        <Buttons>
          {props.agentEnabled && <OpenAssistantButton onClick={props.onToggleAssistant} active={props.assistantOpen} />}
          <OpenNotificationsButton notificationCount={notificationCount} />
          {messagingEnabled && <OpenMessagesButton messageCount={messageCount} />}
          {!props.inAdminView && (
            <DesktopHide>
              <OpenMenuButton toggleMenu={toggleMenu} />
            </DesktopHide>
          )}
        </Buttons>
      </Wrapper>

      {staffCounts && !props.inAdminView && <StaffBar mobileOnly={true} staffCounts={staffCounts} homePage={true} />}
    </MenuHeader>
  )
}

export default HeaderBar
